import { render, staticRenderFns } from "./BrokerID.vue?vue&type=template&id=761091f3&"
import script from "./BrokerID.vue?vue&type=script&lang=js&"
export * from "./BrokerID.vue?vue&type=script&lang=js&"
import style0 from "./BrokerID.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports